import React, { Component } from 'react';
import   SideNav from "./../../component/sidenav/sidenav.js"
import  Moble from "./../../component/sidenav/moble.js"
import "./company.css"
import TimeAgo from 'react-timeago'
import  AuthService  from "../api/authentication.js";

const Auth = new AuthService();
class Campany extends Component {

  constructor(props) {
    super(props)
 
    this.state ={
      noerorrpage :  true,
      hidetemple : false

    }
}

componentDidMount(){
  this.props.noerorrpage(this.state.noerorrpage)


}

selectTemplet=(e)=>{
  e.preventDefault()
  console.log("true select true")
  this.setState({
    hidetemple : true
  })
}
  render() {
    

    return (
        
        
           
                             
          <div>    
              <div className="dashborad-moble-nav-body">
                  
                  {/* < Moble logout={this.logout} isActiveD={this.state.isActive}/> */}
               </div> 

  

              
            
               <SideNav vanImage={this.props.organizer.image_url}   organizers404={this.props.organizers404} email={this.props.user.email}
                logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name}  /> 
                <div className="main">
                    <div>
                    <div class="tabs ">
                        <ul className="company-tabs-costom">
                            <li class="is-active"><a>company profile</a></li>
                            <li><a>messages</a></li>
                            <li><a>products</a></li>
                            <li><a> Edit Website</a></li>
                        </ul>
                     </div>
                    <div className="columns company-costom-dashboard">
                      <div className="column">
                          <div className="tile is-parent">
                                 <article className="tile is-child box">
                                   <div className="dashboard-main-collect-sub-right">
                                       {
                                         this.state.Fmtotal ?
                                         <p>{this.state.Fmtotal}</p>
                                         :
                                         <p>0</p>
                                       }
                                   </div>
                                   <div className=" dashboard-main-collect-sub-left">
                                     <i className="fab fa-wpforms dashboard-main-collect-P"></i>
                                   </div>

                                   <div className="dashboard-main-collect-sub-footer">
                                      <b>Form</b> 
                                   </div>
                               
                                 </article>
                           </div>      
                      </div>
                      <div className="column">
                           <div className="tile is-parent">
                                 <article className="tile is-child box">
                                   <div className="dashboard-main-collect-sub-right">
                                   {
                                         this.state.TKtotal?
                                         <p>{this.state.TKtotal}</p>
                                         :
                                         <p>0</p>
                                       }
                                   </div>
                                   <div className=" dashboard-main-collect-sub-left">
                                   <i className="fas fa-ticket-alt  dashboard-main-collect-P"></i>
                                   
                                   </div>

                                   <div className="dashboard-main-collect-sub-footer">
                                      <b>Ticket</b> 
                                   </div>
                               
                                 </article>
                           </div>  
                      </div>
                      <div className="column">
                         <div className="tile is-parent">
                                 <article className="tile is-child box">
                                   <div className="dashboard-main-collect-sub-right">
                                       0
                                   </div>
                                   <div className=" dashboard-main-collect-sub-left">
                                   <i className="far fa-money-bill-alt dashboard-main-collect-P"></i>
                                   
                                   </div>

                                   <div className="dashboard-main-collect-sub-footer">
                                     <b>Payment</b> 
                                   </div>
                               
                                 </article>
                           </div> 
                      </div>
                      <div className="column">
                         <div className="tile is-parent">
                                 <article className="tile is-child box">
                                   <div className="dashboard-main-collect-sub-right">
                                       0
                                   </div>
                                   <div className=" dashboard-main-collect-sub-left">
                                
                                   <i className="far fa-registered dashboard-main-collect-P"></i>
                                   
                                   </div>

                                   <div className="dashboard-main-collect-sub-footer">
                                      <b>Form registered</b> 
                                   </div>
                               
                                 </article>
                           </div> 
                      
                      </div>
                   
                    </div> 
                
                        
                    </div>
                   
                </div>               
                               
                                 
         </div> 

    )

}





}

export default Campany;


// WEBPACK FOOTER //
// ./src/component/company/company.js